/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Revoke_SuccessInputs */



/**
* | output |
* | --- |
* | "Mailbox disconnected." |
*
* @param {Connections_Outlook_Revoke_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_revoke_success = /** @type {((inputs?: Connections_Outlook_Revoke_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Revoke_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Postfach getrennt.")
	return /** @type {LocalizedString} */ ("Mailbox disconnected.")
});